module.exports = __webpack_public_path__ + "static/media/stephouse.9ab0a8bf.webp";